export default {
  methods: {
    exportImage(picInfo, name) {
      const elink = document.createElement("a")
      elink.download = name
      elink.style.display = "none"
      elink.href = picInfo
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    }
  }
}
